import "./SearchInput.scss";

interface SearchInputProps {
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  className?: string;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

const SearchInput = ({
  value,
  onChange,
  placeholder,
  className = "",
  onKeyDown,
}: SearchInputProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(e.target.value);
    }
  };
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (onKeyDown && e.key === "Enter") {
      onKeyDown(e);
    }
  };
  return (
    <div className={`search-section ${className}`}>
      <div className="search-container">
        <i className="f-icon search-icon"></i>
        <input
          type="text"
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          className="search-input"
        />
      </div>
    </div>
  );
};

export default SearchInput;
